module.exports = __webpack_public_path__ + "static/media/overrun_marker.897b2c38.png";